<template>
  <a-button
    shape="round"
    size="large"
    class="create-btn"
  >
    <template #icon>
      <a-space class="create-btn-text">
        <slot>
          <IconFont
            :type="iconName"
            class="create-btn-text__icon"
          />
        </slot>
        {{ text }}
      </a-space>
    </template>
  </a-button>
</template>

<script>
export default {
  name: 'CreateButton',
  props: {
    text: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="less" scoped>
.create-btn {
  padding-left: 16px;
  padding-right: 16px;
  border: none;
}

.create-btn-text {
  display: flex;
  font-size: 14px;

  &__icon {
    display: block;
    font-size: 20px;
  }
}
</style>
